/**
 * Определяет, что страница открыта во встроенном браузере мессенджера/приложения
 * (in-app webview): Telegram, WhatsApp, VK, Instagram, Facebook и т.п.
 *
 * В таких WebView на iOS (WKWebView) Service Worker'ы работают нестабильно:
 * первый визит по глубокой ссылке часто отдаёт пустой ответ (белый экран),
 * поэтому регистрацию SW в этих условиях лучше пропускать.
 */
export const isInAppBrowser = (): boolean => {
  if (typeof navigator === 'undefined') return false;

  const ua = navigator.userAgent || '';

  // Явные маркеры встроенных браузеров
  const inAppMarkers = [
    'Telegram', // Telegram
    'WhatsApp',
    'VKWebView',
    'VKontakte',
    'Instagram',
    'FBAN',
    'FBAV',
    'FBIOS',
    'MicroMessenger', // WeChat
    'Line/',
    'Snapchat',
    'Twitter',
    'Reddit',
  ];

  if (inAppMarkers.some(marker => ua.includes(marker))) {
    return true;
  }

  // Эвристика для iOS: in-app WebView (мессенджеры, приложения) на iOS
  // часто маскируется под Safari, но при этом НЕ содержит независимых
  // браузерных токенов настоящего Safari (Safari), Chrome (CriOS) или
  // Firefox (FxiOS). На iOS настоящие браузеры всегда добавляют один из
  // этих токенов, а у WebView их нет.
  const isIOS = /iPad|iPhone|iPod/.test(ua);
  if (isIOS) {
    const isSafari = ua.includes('Safari');
    const isChrome = ua.includes('CriOS');
    const isFirefox = ua.includes('FxiOS');
    const isEdge = ua.includes('EdgiOS');
    if (!isSafari && !isChrome && !isFirefox && !isEdge) {
      return true;
    }
  }

  return false;
};
